import { ChatFile } from '../file';

export const REASONING_EFFORTS = [
  'none',
  'minimal',
  'low',
  'medium',
  'high',
  'xhigh',
  'max',
] as const;

export type ReasoningEffort = (typeof REASONING_EFFORTS)[number];

export interface Chat {
  id: string;
  name: string;
  userId: string;
  presetId: string | null;
  createdAt: string;
  updatedAt: string;
}

export type MessageRole = 'USER' | 'ASSISTANT' | 'SYSTEM' | 'TOOL';

export interface AssistantToolCall {
  id: string;
  type: 'function';
  function: {
    name: string;
    arguments: string;
  };
}

export interface ChatMessage {
  id: string;
  role: MessageRole;
  text: string;
  thinking?: string | null;
  toolCalls?: AssistantToolCall | null;
  toolApproved?: boolean | null;
  files?: ChatFile[];
}

export interface ChatDetail extends Chat {
  messages: ChatMessage[];
}

export interface ChatShareLink {
  uid: string;
  lifetime: number | null;
  chatId: string;
  createdAt: string;
}

export interface SharedChatAccess {
  id: string;
  chatId: string;
  lifetime: number | null;
  createdAt: string;
  chat: {
    name: string;
  };
}

export type ChatStreamEvent =
  | { type: 'thinking'; data: string }
  | { type: 'text'; data: string }
  | { type: 'tool_calls'; data: unknown }
  | { type: 'tool_result'; data: { id: string; name: string; result: string } }
  | { type: 'tool_approval_required'; data: ChatMessage[] }
  | { type: 'chat_name'; data: { id: string; name: string } }
  | { type: 'done'; data: ChatMessage }
  | { type: 'error'; data: { message: string } };
